import axios from 'axios';
import useSWR from 'swr';
import { GameLogResponse, PlayerStats } from '@/types/GameLog/res';

const axiosInstanceTwo = axios.create({
  baseURL: 'https://event-message.landrocker.io/',
});

const fetcher = (url: string) => axiosInstanceTwo.get(url).then((res) => res.data);

const usePlayer = () => {
  const { data, error } = useSWR<PlayerStats>('getPlayer', fetcher, {
    refreshInterval: 60000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  return {
    player: data,
    isLoading: !error && !data,
    isError: error,
  };
};

const useLogs = () => {
  const { data, error } = useSWR<GameLogResponse>('getNotif', fetcher, {
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  return {
    logs: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export { usePlayer, useLogs };
